(function(){
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  function getContainer(){ return document.getElementById('sticky-subscription-bar'); }

  function clickThemeBlockForOption(select, scope){
    var idx = select.selectedIndex;
    var blocks = scope.querySelectorAll('.choosesubscriptionproducts .single_product');
    var opt = select.options[idx];
    var planId = opt.getAttribute('data-plan-id') || '';
    var productId = opt.getAttribute('data-product-id') || '';
    var variantId = opt.getAttribute('data-variant-id') || '';
    var targetBlock;
    blocks.forEach(function(block){
      var inner = block.querySelector('.selling_plan_vavaverve');
      if(!inner) return;
      var matchesPlan = (planId === '' && !inner.getAttribute('data-selling-plan-id')) || (String(inner.getAttribute('data-selling-plan-id')) === String(planId));
      var matchesProduct = String(inner.getAttribute('data-product-id')) === String(productId);
      var matchesVariant = String(inner.getAttribute('data-variant-id')) === String(variantId);
      if((planId === '' && matchesVariant) || (matchesPlan && matchesProduct && matchesVariant)){
        targetBlock = block;
      }
    });
    if(targetBlock){ targetBlock.click(); }
  }

  function triggerThemeAddToCart(scope){
    var select = document.getElementById('ssb-purchase-select');
    if(!select) return;
    
    var opt = select.options[select.selectedIndex];
    if(!opt) return;
    
    var planId = opt.getAttribute('data-plan-id') || '';
    var variantId = opt.getAttribute('data-variant-id') || '';
    var productId = opt.getAttribute('data-product-id') || '';
    var addonsIds = opt.getAttribute('data-product-addons') || '';
    
    // Find the custom-subscription component
    var customSubscription = document.querySelector('custom-subscription');
    if(customSubscription){
      // Trigger the subscription component to update
      if(planId === ''){
        // One-time purchase - trigger one-time change
        var tryOnceCard = customSubscription.querySelector('.try-once-card');
        if(tryOnceCard){
          tryOnceCard.click();
        }
      } else {
        // Subscription - trigger subscription change
        var subscribeCard = customSubscription.querySelector('.subscribe-card');
        if(subscribeCard){
          subscribeCard.click();
        }
        
        // Update delivery frequency select if it exists
        var deliverySelect = customSubscription.querySelector('#delivery-frequency-select');
        if(deliverySelect){
          // Find the option that matches the planId
          for(var i = 0; i < deliverySelect.options.length; i++){
            var option = deliverySelect.options[i];
            var optionPlanId = option.getAttribute('data-selling-plan-id') || '';
            if(String(optionPlanId) === String(planId)){
              deliverySelect.selectedIndex = i;
              // Trigger change event
              deliverySelect.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      }
      
      // Wait for the component to update, then submit
      setTimeout(function(){
        var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if(productForm){
          var submitBtn = productForm.querySelector('.product-form__submit, button[type="submit"]');
          if(submitBtn && !submitBtn.disabled){
            submitBtn.click();
          } else if(submitBtn && submitBtn.disabled){
            submitBtn.removeAttribute('disabled');
            submitBtn.classList.add('active');
            setTimeout(function(){
              submitBtn.click();
            }, 100);
          }
        }
      }, 300);
    } else {
      // Fallback: use the old method if custom-subscription component not found
      clickThemeBlockForOption(select, scope);
      setTimeout(function(){
        var productForm = scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
        if(productForm){
          var submitBtn = productForm.querySelector('.product-form__submit, button[type="submit"]');
          if(submitBtn){
            submitBtn.click();
          }
        }
      }, 200);
    }
  }

  ready(function(){
    var container = getContainer();
    if(!container) return;
    var sectionId = container.getAttribute('data-section-id');
    var scope = document.getElementById('ProductInfo-' + sectionId) || document;

    var select = document.getElementById('ssb-purchase-select');
    var button = document.getElementById('ssb-add-to-cart');

    if(select){
      select.addEventListener('change', function(){
        clickThemeBlockForOption(select, scope);
      });
    }

    if(button){
      button.addEventListener('click', function(e){
        e.preventDefault();
        triggerThemeAddToCart(scope);
      });
    }

    // Find the add to cart button
    var addToCartButton = scope.querySelector('.product-form__submit');
    if(addToCartButton){
      // Ensure hidden on load
      container.classList.remove('visible');
      
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          // Show sticky bar only when button is NOT visible (scrolled past it)
          if(entry.isIntersecting){
            container.classList.remove('visible');
          } else {
            // Only add visible if we've scrolled past (button is above viewport)
            var rect = addToCartButton.getBoundingClientRect();
            if(rect.bottom < 0){
              container.classList.add('visible');
            }
          }
        });
      }, { root: null, threshold: 0, rootMargin: '0px' });
      io.observe(addToCartButton);

      // Scroll fallback in case IO is blocked
      var ticking = false;
      function onScroll(){
        if(ticking) return; ticking = true;
        requestAnimationFrame(function(){
          try {
            var rect = addToCartButton.getBoundingClientRect();
            // Only show sticky bar when button has scrolled above viewport
            if(rect.bottom < 0){ 
              container.classList.add('visible'); 
            } else { 
              container.classList.remove('visible'); 
            }
          } catch(e) {}
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      container.classList.add('visible');
    }
  });
})();